import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="border-t-2 border-newsprint/10 py-12 bg-inkwell">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-6">
        <AppLogo size={22} text="QOLLECTIONS" />
        <div className="flex items-center gap-8">
          <a href="#" className="text-newsprint/40 hover:text-acid text-sm transition-colors font-medium">Privacy</a>
          <a href="#" className="text-newsprint/40 hover:text-acid text-sm transition-colors font-medium">Terms</a>
          <a href="#" className="text-newsprint/40 hover:text-acid text-sm transition-colors font-medium">Contact</a>
        </div>
        <p className="font-mono-data text-xs text-newsprint/30">© 2026 Qollections</p>
      </div>
    </footer>
  );
}